import { toast } from 'react-hot-toast';

export const showSuccess = ((message)=>{
    toast.success(message, {
        position: "bottom-right",
        style: {
            background: "#101010",
            color: "#fff"
        }
    })  
})

export const showError = ((error)=>{
    toast.error(error, {
        position: "bottom-right",
        style: {
            background: "#101010",
            color: "#fff"
        }
    })  
})